export default "__VITE_ASSET__I$qY1WvQ__"